import { useMemo, useState } from "react";
import { Chip, ListShell, PersonRow, fmtMelb, matches } from "./shared";
import { useTeamReport } from "./useTeamReport";

const byName = (a, b) => (a.name || "").localeCompare(b.name || "");
const SORTS = {
  name: byName,
  most: (a, b) => b.completed - a.completed || byName(a, b),
  // Never started counts as least recently active, so they sort first.
  stale: (a, b) => (a.last_activity_at || "").localeCompare(b.last_activity_at || "") || byName(a, b),
};

export default function BootcampView({ scope, q, rowProps }) {
  const [sort, setSort] = useState("name");
  const data = useTeamReport("bootcamp", { scope });
  const rows = useMemo(() => (data ? data.rows.filter((r) => matches(r, q)).sort(SORTS[sort]) : null), [data, q, sort]);
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        <Chip active={sort === "name"} onClick={() => setSort("name")} testid="bc-sort-name">A–Z</Chip>
        <Chip active={sort === "most"} onClick={() => setSort("most")} testid="bc-sort-most">Most completed</Chip>
        <Chip active={sort === "stale"} onClick={() => setSort("stale")} testid="bc-sort-stale">Least recently active</Chip>
      </div>
      <ListShell rows={rows} testid="bc-list" empty={q ? "No one matches your search." : "No partners in this group yet."}>
        {(rows || []).map((r) => (
          <PersonRow key={r.id} u={r} prefix="bc" {...rowProps}>
            <div className="flex items-center gap-x-2 gap-y-1 mt-1.5 flex-wrap text-[11px] text-slate-600 tabular-nums" data-testid={`bc-progress-${r.id}`}>
              <div className="h-1.5 w-24 rounded-full bg-slate-100 overflow-hidden shrink-0">
                <div className="h-full bg-[#C9A961] transition-[width] duration-500" style={{ width: `${r.pct}%` }} />
              </div>
              <span><b className="text-[#0A1F44]">{r.completed}/{r.total}</b> days completed · {r.pct}%</span>
              <span>{r.current_day ? `Current day ${r.current_day}` : "All days complete"}</span>
              <span className="text-slate-400 w-full">
                {r.started ? `Last Bootcamp activity ${fmtMelb(r.last_activity_at)}` : "Not started yet"}
              </span>
            </div>
          </PersonRow>
        ))}
      </ListShell>
    </div>
  );
}
